import React from 'react';
import { useLocation } from 'react-router-dom';

// A custom hook that builds on useLocation to parse
export default function useQuery() {
  const { search } = useLocation();

    return React.useMemo(() => {
        const urlParams = new URLSearchParams(search);
        return Object.fromEntries(urlParams.entries());
    }, [search]);
}
